import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["columnName", "requiredCellProps", "row"];
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { useAccessLevel } from 'customer-data-properties/accessLevel/AccessLevelContext';
import { HIDDEN } from 'customer-data-objects/property/AccessLevel';
import UIFloatingForm from 'UIComponents/form/UIFloatingForm';
import { getProperties } from '../../selectors/properties';
import CloseDateCellDecorator from './CloseDateCellDecorator';
import DatePicker from './DatePicker';
import PropertyInputHidden from './PropertyInputHidden';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledDecoratedCell = styled.div.withConfig({
  displayName: "CloseDateCell__StyledDecoratedCell",
  componentId: "sc-15iag1w-0"
})(["display:flex;align-items:center;"]);
const DealCloseDateCell = _ref => {
  let {
      columnName,
      requiredCellProps,
      row
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const propertyDefinition = useSelector(getProperties)[columnName];

  // Since this is a handrolled cell renderer, we must manually handle access ourselves
  const accessLevel = useAccessLevel({
    objectType: 'DEAL',
    propertyName: columnName
  });
  const isHiddenAccess = accessLevel === HIDDEN;
  return /*#__PURE__*/_jsx("td", Object.assign({}, requiredCellProps, {
    children: isHiddenAccess ? /*#__PURE__*/_jsx(PropertyInputHidden, {
      property: propertyDefinition
    }) : /*#__PURE__*/_jsxs(StyledDecoratedCell, {
      children: [/*#__PURE__*/_jsx(UIFloatingForm, {
        children: /*#__PURE__*/_jsx(DatePicker, Object.assign({
          columnName: columnName,
          requiredCellProps: requiredCellProps,
          row: row
        }, props))
      }), /*#__PURE__*/_jsx(CloseDateCellDecorator, {
        history: row.history
      })]
    })
  }));
};
export default DealCloseDateCell;